import {
	ApplicationRef,
	ComponentRef,
	EmbeddedViewRef,
	Injectable,
	ViewContainerRef,
} from '@angular/core';
import { LoadingAnimationContainerComponent } from './loading-animation-container/loading-animation-container.component';

import { combineLatest, delay, first, of, race, Subject, Subscription } from 'rxjs';

@Injectable()
export class LoadingAnimationService {
	private dialogComponentRef!: ComponentRef<LoadingAnimationContainerComponent>;
	private minimumLoadingAnimationShowTime: number = 1000;
	private softClosed$: Subject<boolean> = new Subject<boolean>();
	private forceClosed$: Subject<boolean> = new Subject<boolean>();
	private subscriptionForClose$: Subscription | null = null;

	constructor(private readonly appRef: ApplicationRef) {}
	public open(minimumShowTime: number = this.minimumLoadingAnimationShowTime) {
		this.appendDialogComponentToBody();

		if (this.subscriptionForClose$ !== null) {
			this.subscriptionForClose$.unsubscribe();
		}
		this.subscriptionForClose$ = race(
			combineLatest([of('dummy').pipe(delay(minimumShowTime)), this.softClosed$]).pipe(first()),
			this.forceClosed$,
		).subscribe(() => {
			this.removeDialogComponentFromBody();
			this.subscriptionForClose$?.unsubscribe();
			this.subscriptionForClose$ = null;
		});
	}

	public close() {
		this.softClosed$.next(true);
	}

	public forceClose() {
		this.forceClosed$.next(true);
	}
	private appendDialogComponentToBody() {
		const componentRef = this.getRootViewContainerRef().createComponent(
			LoadingAnimationContainerComponent,
		);

		const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
		document.body.appendChild(domElem);

		this.dialogComponentRef = componentRef;
	}

	private getRootViewContainerRef(): ViewContainerRef {
		const appInstance = this.appRef.components[0].instance;

		if (!appInstance.viewContainerRef) {
			const appName = this.appRef.componentTypes[0].name;
			throw new Error(`Missing 'viewContainerRef' declaration in ${appName} constructor`);
		}

		return appInstance.viewContainerRef;
	}

	private removeDialogComponentFromBody() {
		this.appRef.detachView(this.dialogComponentRef.hostView);
		this.dialogComponentRef.destroy();
	}
}
